import { makeStyles } from 'tss-react/mui';

export const useSectionStyles = makeStyles()((theme) => ({
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  gap2: {
    gap: theme.spacing(2)
  },
  max336: {
    maxWidth: '336px'
  },
  fontWeight500: {
    fontWeight: 500
  },
  radioMargin: {
    '& *[role=radiogroup]': {
      marginLeft: theme.spacing(1),
    }
  },
  inputBackgroundWhite: {
    //   this targets the base input
    '& > div': {
      background: theme.palette.common.white
    }
  },
  inlineRadio: {
    '& > label': {
      width: '94px',
    },
  },
  greyBackground: {
    background: theme.palette.grey[100]
  },
  lightRedBackground: {
    // don't know if this is in codebase (used a color picker on a figma screenshot to get this)
    background: '#fceae7'
  },
  visibilityHidden: {
    visibility: 'hidden'
  },
  buttonStyleCheckboxGroup: {
    width: '100%'
  },
}));
